
export default {
  data() {
    return {
      title: "Sustainability | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
